export const SET_TALENT_POOLS = "SET_TALENT_POOLS";
export const SET_CURRENT_TALENT_POOL = "SET_CURRENT_TALENT_POOL";
export const SET_IS_FETCHING_TALENT_POOLS = "SET_FETCHING_TALENT_POOLS";
export const SET_IS_FETCHING_CURRENT_TALENT_POOL =
  "SET_IS_FETCHING_CURRENT_TALENT_POOL";

import { setStoreValue } from "@/store/utils";

const mutations = {
  [SET_TALENT_POOLS]: setStoreValue("talentPools"),
  [SET_IS_FETCHING_TALENT_POOLS]: setStoreValue("isFetchingTalentPools"),
  [SET_CURRENT_TALENT_POOL]: setStoreValue("currentTalentPool"),
  [SET_IS_FETCHING_CURRENT_TALENT_POOL]: setStoreValue(
    "isFetchingCurrentTalentPool"
  )
};

export default mutations;
